import React from 'react';
import { useRouter } from 'react-resource-router';

import { HomepageRoute } from '@townsquare/router/route-types';
import { isGateEnabled } from '@townsquare/stat-sig/gate';

import { TownsquareContextInternal } from './components/context';
import type { AppConfig, Apps } from './types';

export const useIsTownsquareRoute = () => {
  const [routerState] = useRouter();
  return (routerState.route as HomepageRoute).subproduct?.startsWith('townsquare-');
};

export const useTownsquareContext = () => {
  return React.useContext(TownsquareContextInternal);
};

export const useTownsquareApp = () => {
  const ctx = React.useContext(TownsquareContextInternal);

  return ctx.app;
};

const defaultAppConfig: AppConfig = {
  appDisplayName: 'Home',
  showHomeSettings: true,
  showGoalSettings: false,
};

const appConfigs: Map<Apps, AppConfig> = new Map([
  ['teams', { appDisplayName: 'Teams', showHomeSettings: false, showGoalSettings: false }],
  ['goals', { appDisplayName: 'Goals', showHomeSettings: true, showGoalSettings: true }],
]);

export const useTownsquareAppConfig = () => {
  const app = useTownsquareApp();
  const appConfig = appConfigs.get(app);
  const shouldUseAppConfig =
    !!appConfig && (isGateEnabled('atlas_teams_app_enabled') || isGateEnabled('atlas_goals_app_enabled'));

  return shouldUseAppConfig ? appConfig : defaultAppConfig;
};
